import * as CurrencyFormatter from 'currencyformatter.js';
import { Devices } from './types';
import { ORIGIN_URL } from '../api/constants';
import paths from '../routing/paths';

export const noop = () => {};

export function sortByProperty(property: string) {
  return (a, b) => {
    if (typeof a[property] !== 'undefined' && typeof b[property] !== 'undefined') {
      return a[property] - b[property] || a[property].localeCompare(b[property]);
    }
    return 1;
  };
}

export function sortByCount(a, b): 0 | 1 | -1 {
  if (a.count < b.count) {
    return 1;
  }
  if (a.count > b.count) {
    return -1;
  }
  return 0;
}

export function formatPrice(price: number): string {
  return CurrencyFormatter.format(price, { currency: 'EUR', locale: 'fr' });
}

export function getIsClient(): boolean {
  return Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
}

export function persistData(key: string, data: any): boolean {
  try {
    localStorage.setItem(key, JSON.stringify(data));
    return true;
  } catch {
    return false;
  }
}

export function getPersistedData(key: string): any | null {
  try {
    const data = localStorage.getItem(key);
    if (data) {
      return JSON.parse(data);
    }
    return null;
  } catch {
    return null;
  }
}

export function findDevice(userAgent: string): Devices {
  if (/Tablet|iPad|Silk/.test(userAgent)) {
    return Devices.tablet;
  } else if (/Mobile|iP(hone|od)|Android/.test(userAgent)) {
    return Devices.mobile;
  }
  return Devices.desktop;
}

export function scrollToTop() {
  if (getIsClient()) {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }
}

export function removeTrailingSlash(value: string): string {
  return value.replace(/\/$/, '');
}

export function getCanonicalUrl(pathname: string): string {
  return pathname !== paths.HOME
    ? removeTrailingSlash(`${ORIGIN_URL}${pathname}`)
    : `${ORIGIN_URL}/`;
}

export const isButtonToDisplay = (textRef: React.RefObject<HTMLDivElement> | null) => {
  if (textRef?.current) {
    return textRef.current.offsetHeight < textRef.current.scrollHeight;
  }
  return false;
};
